/* eslint-disable import/no-unresolved */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FeatureCollection } from 'geojson';
import { useEffect, useState } from 'react';

export const useMunicipalityLayer = (): FeatureCollection | null => {
	const [collection, setCollection] = useState<FeatureCollection | null>(null);

	useEffect(() => {
		const fetchFeatureCollection = async () => {
			const featureCollection = await import(
				// @ts-ignore
				'/static/flemishMunicipalitiesLayer.json'
			);

			// Set data with the result
			setCollection(featureCollection.default);
		};

		fetchFeatureCollection().catch(console.error);
	}, []);

	return collection;
};
